import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IBlog } from 'src/app/shared/interfaces/blog';
import { ApiService } from 'src/app/shared/services/api.service';

@Component({
  selector: 'app-blog-detail',
  templateUrl: './blog-detail.component.html',
  styleUrl: './blog-detail.component.css'
})
export class BlogDetailComponent implements OnInit {

  blogId: any;
  blogModel: IBlog;


  constructor(
    public apiService: ApiService,
    private route: ActivatedRoute
  ){}

  ngOnInit(): void {
    this.blogId = this.route.snapshot.params.id;

    this.getBlogDetail();
  }

  getBlogDetail() {
    this.apiService.apiCall('get', '/api/SitesBlog/GetBlogDetails/' + this.blogId).subscribe((res: any) => {
      console.log(res);
      this.blogModel = res.body.model;
      
    })
  }


}
